
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"st0",attrs:{"cx":"16","cy":"16","r":"11"}}),_c('path',{staticClass:"st1",attrs:{"d":"M16 16v6M19.5 11L16 16l-3.5-5M13.5 16h5M13.5 18h5"}})])
          )
        }
      }
    